(() => {
  const normalize = (value) => (value || '')
    .toLocaleLowerCase()
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .trim();

  const init = (section) => {
    if (!section || section.dataset.whereToBuyReady === 'true') return;
    section.dataset.whereToBuyReady = 'true';

    const search = section.querySelector('[data-where-to-buy-search]');
    const cards = [...section.querySelectorAll('[data-where-to-buy-card]')];
    const pins = [...section.querySelectorAll('[data-where-to-buy-pin]')];
    const empty = section.querySelector('[data-where-to-buy-empty]');
    const suggestion = section.querySelector('[data-where-to-buy-suggestion]');
    const suggestionName = section.querySelector('[data-where-to-buy-suggestion-name]');

    const findCard = (country) => {
      const target = normalize(country);
      return cards.find((card) => normalize(card.dataset.countryName).includes(target));
    };

    const selectCountry = (countryId, shouldScroll = false) => {
      cards.forEach((card) => card.classList.toggle('is-selected', card.dataset.countryId === countryId));
      pins.forEach((pin) => pin.setAttribute('aria-pressed', String(pin.dataset.countryId === countryId)));
      const selected = cards.find((card) => card.dataset.countryId === countryId);
      if (selected && shouldScroll) selected.scrollIntoView({ behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth', block: 'center' });
    };

    pins.forEach((pin) => pin.addEventListener('click', () => selectCountry(pin.dataset.countryId, true)));

    const filter = () => {
      const query = normalize(search?.value);
      let visible = 0;
      cards.forEach((card) => {
        const matches = !query || normalize(card.dataset.search).includes(query);
        card.hidden = !matches;
        if (matches) visible += 1;
      });
      pins.forEach((pin) => {
        const card = cards.find((item) => item.dataset.countryId === pin.dataset.countryId);
        pin.hidden = Boolean(query && card?.hidden);
      });
      if (empty) empty.hidden = visible !== 0;
    };

    search?.addEventListener('input', filter);
    search?.addEventListener('search', filter);

    const showSuggestion = (country) => {
      const card = findCard(country);
      if (!card || !suggestion || !suggestionName) return false;
      suggestionName.textContent = card.dataset.countryEnglish;
      suggestion.hidden = false;
      return true;
    };

    const suggestCountry = async () => {
      let country;
      try {
        const root = window.Shopify?.routes?.root || '/';
        const response = await fetch(`${root}browsing_context_suggestions.json?country[enabled]=true`, { headers: { Accept: 'application/json' } });
        if (response.ok) {
          const result = await response.json();
          country = result.suggestions?.[0]?.parts?.country?.name || result.detected_values?.country?.name;
        }
      } catch (_) {
        // Fall back to Shopify localization below.
      }
      showSuggestion(country || section.dataset.currentCountry);
    };

    suggestCountry();
  };

  document.querySelectorAll('[data-where-to-buy]').forEach(init);
  document.addEventListener('shopify:section:load', (event) => init(event.target.querySelector('[data-where-to-buy]')));
})();
